import { z } from "zod";
import { PaginationQuerySchema } from "./common.js";
import { CrmDealPrioritySchema } from "./crm-deals.js";
export const CrmFollowUpStatusValues = ["open", "completed", "skipped", "archived"];
export const CrmFollowUpChannelValues = ["task", "email", "call", "meeting", "linkedin"];
export const CrmSalesSequenceTemplateValues = [
    "outbound_first_touch",
    "proposal_chase",
    "dormant_reengage",
];
export const CrmFollowUpStatusSchema = z.enum(CrmFollowUpStatusValues);
export const CrmFollowUpChannelSchema = z.enum(CrmFollowUpChannelValues);
export const CrmSalesSequenceTemplateSchema = z.enum(CrmSalesSequenceTemplateValues);
const nullableUuid = z.string().uuid().nullable().optional();
const nullableEmail = z.string().email().nullable().optional();
export const CrmFollowUpSchema = z.object({
    id: z.string().uuid(),
    title: z.string().min(1).max(200),
    description: z.string().nullable().default(null),
    status: CrmFollowUpStatusSchema,
    priority: CrmDealPrioritySchema,
    channel: CrmFollowUpChannelSchema,
    ownerEmail: z.string().email().nullable().default(null),
    dueAt: z.string().datetime(),
    completedAt: z.string().datetime().nullable().default(null),
    completedBy: z.string().email().nullable().default(null),
    skippedAt: z.string().datetime().nullable().default(null),
    skippedBy: z.string().email().nullable().default(null),
    skippedReason: z.string().nullable().default(null),
    sequenceInstanceId: z.string().uuid().nullable().default(null),
    sequenceName: z.string().nullable().default(null),
    sequenceStep: z.number().int().positive().nullable().default(null),
    sequenceTotal: z.number().int().positive().nullable().default(null),
    dealId: z.string().uuid().nullable().default(null),
    dealName: z.string().nullable().default(null),
    contactId: z.string().uuid().nullable().default(null),
    contactName: z.string().nullable().default(null),
    companyId: z.string().uuid().nullable().default(null),
    companyName: z.string().nullable().default(null),
    campaignId: z.string().uuid().nullable().default(null),
    campaignName: z.string().nullable().default(null),
    archivedAt: z.string().datetime().nullable().default(null),
    archivedBy: z.string().email().nullable().default(null),
    createdBy: z.string().email(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
const CrmFollowUpMutationBaseSchema = z.object({
    title: z.string().trim().min(1).max(200),
    description: z.string().trim().max(5000).nullable().optional(),
    priority: CrmDealPrioritySchema.default("medium"),
    channel: CrmFollowUpChannelSchema.default("task"),
    ownerEmail: nullableEmail,
    dueAt: z.string().datetime(),
    dealId: nullableUuid,
    contactId: nullableUuid,
    companyId: nullableUuid,
    campaignId: nullableUuid,
});
export const CrmFollowUpCreateSchema = CrmFollowUpMutationBaseSchema.refine((data) => Boolean(data.dealId || data.contactId || data.companyId || data.campaignId), "Follow-up must be linked to a deal, contact, company, or campaign");
export const CrmFollowUpUpdateSchema = CrmFollowUpMutationBaseSchema.partial().refine((value) => Object.keys(value).length > 0, "At least one field must be supplied");
export const CrmFollowUpListQuerySchema = PaginationQuerySchema.extend({
    status: CrmFollowUpStatusSchema.optional(),
    ownerEmail: z.string().email().optional(),
    dueBefore: z.string().datetime().optional(),
    dueAfter: z.string().datetime().optional(),
    dealId: z.string().uuid().optional(),
    contactId: z.string().uuid().optional(),
    companyId: z.string().uuid().optional(),
    campaignId: z.string().uuid().optional(),
    includeArchived: z.coerce.boolean().optional(),
    archivedOnly: z.coerce.boolean().optional(),
});
export const CrmFollowUpListResponseSchema = z.object({
    followUps: z.array(CrmFollowUpSchema),
    total: z.number().int(),
});
export const CrmFollowUpParamSchema = z.object({
    id: z.string().uuid(),
});
export const CrmFollowUpSkipSchema = z.object({
    reason: z.string().trim().min(1).max(1000),
});
export const CrmSalesSequenceStartSchema = z
    .object({
    template: CrmSalesSequenceTemplateSchema,
    ownerEmail: nullableEmail,
    startAt: z.string().datetime().optional(),
    dealId: nullableUuid,
    contactId: nullableUuid,
    companyId: nullableUuid,
    campaignId: nullableUuid,
})
    .refine((data) => Boolean(data.dealId || data.contactId || data.companyId || data.campaignId), "Sequence must be linked to a deal, contact, company, or campaign");
export const CrmSalesSequenceStartResponseSchema = z.object({
    sequenceInstanceId: z.string().uuid(),
    template: CrmSalesSequenceTemplateSchema,
    followUps: z.array(CrmFollowUpSchema),
});
//# sourceMappingURL=crm-follow-ups.js.map